import React from 'react';

const pulse = {
    background: 'linear-gradient(90deg, var(--ap-surface-2, #f1f5f9) 25%, var(--ap-surface-3, #e2e8f0) 50%, var(--ap-surface-2, #f1f5f9) 75%)',
    backgroundSize: '200% 100%',
    animation: 'ap-skeleton-pulse 1.4s ease infinite',
    borderRadius: 6,
};

const styleTag = typeof document !== 'undefined' && !document.getElementById('ap-skeleton-style') && (() => {
    const s = document.createElement('style');
    s.id = 'ap-skeleton-style';
    s.textContent = '@keyframes ap-skeleton-pulse { 0%{background-position:200% 0} 100%{background-position:-200% 0} }';
    document.head.appendChild(s);
})();

function Block({ w = '100%', h = 16, mb = 8, br = 6 }) {
    return <div style={{ ...pulse, width: w, height: h, marginBottom: mb, borderRadius: br }} />;
}

export function DashboardSkeleton() {
    return (
        <div style={{ padding: '28px 32px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
                {[0, 1, 2, 3].map(i => (
                    <div key={i} style={{ background: 'var(--ap-surface-2, #f8fafc)', border: '1px solid var(--ap-border, #e2e8f0)', borderRadius: 10, padding: 20 }}>
                        <Block w="50%" h={12} mb={12} />
                        <Block w="40%" h={28} mb={8} />
                        <Block w="70%" h={10} mb={0} />
                    </div>
                ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
                {[0, 1].map(i => (
                    <div key={i} style={{ background: 'var(--ap-surface-2, #f8fafc)', border: '1px solid var(--ap-border, #e2e8f0)', borderRadius: 10, padding: 20, height: 220 }}>
                        <Block w="45%" h={14} mb={16} />
                        <Block w="100%" h={140} mb={0} br={8} />
                    </div>
                ))}
            </div>
            <div style={{ background: 'var(--ap-surface-2, #f8fafc)', border: '1px solid var(--ap-border, #e2e8f0)', borderRadius: 10, padding: 20 }}>
                <Block w="30%" h={14} mb={16} />
                {[0, 1, 2, 3, 4].map(i => (
                    <Block key={i} w="100%" h={36} mb={8} />
                ))}
            </div>
        </div>
    );
}

export function KpiPageSkeleton() {
    return (
        <div style={{ padding: '28px 32px' }}>
            <Block w="200px" h={22} mb={20} />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
                {[0, 1, 2].map(i => (
                    <div key={i} style={{ background: 'var(--ap-surface-2, #f8fafc)', border: '1px solid var(--ap-border, #e2e8f0)', borderRadius: 10, padding: 20 }}>
                        <Block w="60%" h={12} mb={12} />
                        <Block w="45%" h={28} mb={8} />
                        <Block w="80%" h={10} mb={0} />
                    </div>
                ))}
            </div>
            <div style={{ background: 'var(--ap-surface-2, #f8fafc)', border: '1px solid var(--ap-border, #e2e8f0)', borderRadius: 10, padding: 20 }}>
                <Block w="35%" h={14} mb={16} />
                {[0, 1, 2, 3, 4, 5].map(i => (
                    <Block key={i} w="100%" h={40} mb={8} />
                ))}
            </div>
        </div>
    );
}
